<template>
    <div>
        <v-dialog v-model="dialogVisible" max-width="900px" persistent>
            <v-card>
                <v-card-title class="primary white--text">
                    <v-icon left color="white">mdi-file-document</v-icon>
                    Náhľad dohody o dare
                    <v-spacer></v-spacer>
                    <v-btn icon color="white" @click="closeDialog">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pa-6">
                    <!-- Upozornenie o stave zmluvy -->
                    <v-alert type="warning" outlined class="mb-4">
                        <v-row align="center">
                            <v-col>
                                <strong>DÁTUM PLATNOSTI A ÚČINNOSTI TEJTO DOHODY:</strong>
                                <span v-if="!contractEffectiveDate" class="red--text ml-2">
                                    Dohoda zatiaľ nie je platná, lebo suma Daru zatiaľ nebola pripísaná na náš
                                    účet.
                                </span>
                                <span v-else class="green--text ml-2">
                                    {{ formatDate(contractEffectiveDate) }}
                                </span>
                            </v-col>
                        </v-row>
                    </v-alert>

                    <!-- Obsah zmluvy -->
                    <div class="contract-content" id="contract-content">
                        <pre class="contract-template">DOHODA O DARE
(individuálna dohoda uzatváraná elektronicky)

I. Zmluvné strany

1. Spoločnosť
Obchodné meno: FICHEE GROUP s.r.o.
IČO: 51 851 491
Sídlo: Páričkova 5, 821 08 Bratislava, Slovenská republika
Štatutárny orgán: konateľ Boris Wagner
IBAN: SK98 8330 0000 0091 1199 1119
(ďalej len „Spoločnosť“)

a

2. Darca
Meno a priezvisko: {{ userInfo.first_name }} {{ userInfo.last_name }}
Adresa trvalého pobytu: {{ userInfo.address }}
IBAN: {{ userInfo.bank_account }}
ID Darcu na platforme FICHEE MEDIA: {{ userInfo.id }}
(ďalej len „Darca“)


II. Predmet Dohody

Predmetom tejto Dohody je poskytnutie peňažného Daru Darcom za účelom kapitalizácie 10 projektov skupiny FICHEE GROUP.
Celkový cieľový plánovaný objem Daru je 10 000 000 €.
Dary sú sústreďované na bankovom účte Spoločnosti uvedenom v článku I, bod 1.
V prípade zmeny vlastníctva Spoločnosti alebo jej bankového účtu prechádzajú všetky práva a povinnosti z tejto Dohody na právneho nástupcu Spoločnosti.


III. Projekty skupiny FICHEE GROUP

Medzi 10 projektov, ktorých vývoj sa financuje prostriedkami podľa tejto Dohody patria tieto projekty:

NAMEC - NÁŠ MEŠEC
NAŠICA - NAŠA TRŽNICA
CENADNESKA.SK
NAŠOVISKO - NAŠE DOVOLENKOVISKO
NASTRÁŽ - NAŠA STRÁŽ
FICHEE MEDIA
FICHEEADS
LOCH PUB
FICHEE TAXI
FICHEE

Tieto projekty sú bližšie špecifikované na adrese fmedia.top v sekcií DAR PRE SLOVENSKO.


IV. Špecifikácia Daru

ID Daru: {{ investmentId }}
Dátum vytvorenia: {{ formatDate(proposalDate) }}
Výška Daru: {{ formatCurrency(investmentAmount) }}
Dátum účinnosti: deň pripísania Daru na účet Spoločnosti.
Ak suma daru ešte nebola pripísaná, dohoda nenadobúda účinnosť.


V. Podmienky platnosti

Dohoda nadobúda platnosť a účinnosť výlučne dňom pripísania Daru na účet Spoločnosti.
Právne vzťahy neupravené touto Dohodou sa riadia právnym poriadkom Slovenskej republiky.


VI. Špeciálne vysvetlenie

Táto Dohoda o Dare mala byť pôvodne Dohoda o investícií. Jej znenie prikladáme ako prílohu pre zaujímavosť ako mal zmluvný vzťah pôvodne vyzerať.
Právne dôsledky priloženej Dohody o investícií nemajú žiadnu právnu silu v súvislosti s týmto Darom podľa tejto Dohody o Dare..
Zároveň využívame tento pôvodný formulár na webe fmedia.top so zmenenými slovnými formuláciami kde investíciu nahrádzame darom a aj všetko s tým spojené ako evidenciu Darov.
Nikde nie je napísané, že spoločnosť niekedy nemôže obdarovať Darcov, tak len aby sa vedelo koho a za čo.</pre>

                        <div class="appendix-title">Príloha.</div>

                        <pre class="contract-template contract-template--appendix">

DOHODA O INVESTÍCII
(individuálna dohoda uzatváraná elektronicky)

I. Zmluvné strany

1. Spoločnosť
Obchodné meno: FICHEE GROUP s.r.o.
IČO: 51 851 491
Sídlo: Páričkova 5, 821 08 Bratislava, Slovenská republika
Štatutárny orgán: konateľ Boris Wagner
IBAN: SK98 8330 0000 0091 1199 1119
(ďalej len „Spoločnosť“)

a

2. Investor
Meno a priezvisko: {{ userInfo.first_name }} {{ userInfo.last_name }}
Adresa trvalého pobytu: {{ userInfo.address }}
IBAN: {{ userInfo.bank_account }}
ID investora na platforme FICHEE MEDIA: {{ userInfo.id }}
(ďalej len „Investor“)


II. Predmet Dohody

Predmetom tejto Dohody je poskytnutie peňažného vkladu Investorom za účelom kapitalizácie 10 projektov skupiny FICHEE GROUP.
Celkový cieľový plánovaný objem investičného kapitálu je 10 000 000 €.
Investičné prostriedky sú sústreďované na bankovom účte Spoločnosti uvedenom v článku I, bod 1.
V prípade zmeny vlastníctva Spoločnosti alebo jej bankového účtu prechádzajú všetky práva a povinnosti z tejto Dohody na právneho nástupcu Spoločnosti.


III. Projekty skupiny FICHEE GROUP

Medzi 10 projektov, ktorých vývoj sa financuje kapitalizáciou podľa tejto Dohody patria tieto projekty:

NAMEC - NÁŠ MEŠEC
NAŠICA - NAŠA TRŽNICA
CENADNESKA.SK
NAŠOVISKO - NAŠE DOVOLENKOVISKO
NASTRÁŽ - NAŠA STRÁŽ
FICHEE MEDIA
FICHEEADS
LOCH PUB
FICHEE TAXI
FICHEE

Tieto projekty sú bližšie špecifikované na adrese fmedia.top v sekcií DAR PRE SLOVENSKO.


IV. Špecifikácia investície

ID investície: {{ investmentId }}
Dátum vytvorenia: {{ formatDate(proposalDate) }}
Výška investície: {{ formatCurrency(investmentAmount) }}
Celková suma na výplatu vrátane benefitného koeficientu {{ formatCurrency(investmentAmount * currentCoefficient) }}
Dátum účinnosti: deň pripísania investície na účet Spoločnosti.
Ak investícia ešte nebola pripísaná, Dohoda nenadobúda účinnosť.


V. Podmienky platnosti

Dohoda nadobúda platnosť a účinnosť výlučne dňom pripísania investície na účet Spoločnosti.
Právne vzťahy neupravené touto Dohodou sa riadia právnym poriadkom Slovenskej republiky.
Dohoda zaniká splnením záväzku Spoločnosti vyplatiť Investorovi celkový nárokovaný benefit podľa tejto Dohody.


VI. Podmienky investície

Minimálna investícia: 10 €
Maximálna investícia jednej individuálnej transakcie: 10 000 €
Investícia musí byť násobkom 10 €.
Suma nižšia ako 10 € alebo suma, ktorá nie je násobkom 10 €, sa považuje za dar bez nároku na benefit.
Investor môže investovať opakovane; jednotlivé investície sa kumulujú.
Spoločnosť si vyhradzuje právo ukončiť prijímanie investícií pred dosiahnutím cieľovej sumy 10 000 000 €.
Vyššie investície presahujúce sumu 10.000 € sú možné na základe individuálnej dohody.


VII. Koeficient benefitu

Každá jednotlivá investícia má pridelený benefitný koeficient podľa stavu celkového vyzbieraného kapitálu ku dňu a času jej pripísania na náš účet Spoločnosti uvedenom v článku I, bod 1.

Interval investičného kapitálu		Koeficient
0 – 1 000 000 €			5×
1 000 001 – 2 000 000 €		4×
2 000 001 – 3 000 000 €		3×
3 000 001 – 4 000 000 €		2×
4 000 001 – 10 000 000 €		1,5×

Rozhodujúci je moment pripísania investície na účet Spoločnosti uvedenom v článku I, bod 1.


VII. Mechanizmus vyplácania

1.    Každý druhý mesiac sa vypočíta súčet všetkých tržieb všetkých aktívnych projektov podľa článku iiI, bod 1. za posledné dva mesiace.
2.    Na výplatu Investorom sa použije 50 % až 70 % z týchto tržieb (určí Spoločnosť).
3.    Výplata sa realizuje len ak mesačné tržby dosiahnu minimálne 300 000 €.
4.    Investor má nárok na alikvotný podiel z vyplácanej sumy podľa pomeru:

    Hodnota jeho investície vrátane benefitného koeficientu
    -----------------------------------------------
                  10 000 000 €

5.    Vyplácanie prebieha až do naplnenia celkového násobku jeho investície podľa článku VII.


VIII. Prevod a dedenie
Investícia nie je prevoditeľná, okrem prípadu dedenia podľa právnych predpisov SR.


IX. Účtovné a právne ustanovenia

Investícia predstavuje kapitálový vklad podľa tejto Dohody.
Výplata benefitu predstavuje náklad Spoločnosti.
Dohoda sa uzatvára na dobu určitú do splnenia záväzkov.


INTERPRETAČNÁ DOLOŽKA

„Investícia“ = konkrétny peňažný vklad Investora
„Koeficient“ = násobok určujúci maximálnu výšku benefitu
„Benefit“ = celková suma, ktorú má Investor nárok získať


PRÍKLAD VÝPOČTU

Vstupné údaje

Tržba mesiac 1: 450 000 €
Tržba mesiac 2: 550 000 €
Spolu: 1 000 000 €
Podiel na výplatu: 70 %
Suma určená na výplatu investorom:

1 000 000 × 0,70 = 700 000 €



Investorove investície

1.    Investícia 300 € s koeficientom 5×

    300 × 5 = 1 500 €

2.    Investícia 700 € s koeficientom 4×

    700 × 4 = 2 800 €

Celková hodnota investora pre výpočet podielu:

    1 500 + 2 800 = 4 300 €



Alikvotný podiel investora

              4 300
          ----------- = 0,00043
           10 000 000


Konkrétna periodická platba

    700 000 × 0,00043 = 301 €


Výsledok

Konkrétny Drobný investor dostane za dané obdobie: 301 €</pre>
                    </div>
                </v-card-text>

                <v-card-actions class="pa-6">
                    <v-btn color="grey" outlined @click="closeDialog">
                        <v-icon left>mdi-close</v-icon>
                        Zavrieť
                    </v-btn>

                    <!-- <v-btn color="info" outlined @click="downloadContractPDF" :loading="pdfLoading">
                    <v-icon left>mdi-download</v-icon>
                    Stiahnuť PDF
                </v-btn> -->

                    <v-spacer></v-spacer>

                    <v-btn color="success" large @click="confirmInvestment" :loading="loading">
                        <v-icon left>mdi-check</v-icon>
                        Súhlasím a chcem odoslať Dar
                    </v-btn>
                </v-card-actions>
            </v-card>

            <!-- Confirmation Dialog -->
            <v-dialog v-model="confirmationDialog" max-width="500px" persistent>
                <v-card>
                    <v-card-title class="warning white--text">
                        <v-icon left color="white">mdi-alert</v-icon>
                        Potvrdenie Daru
                    </v-card-title>
                    <v-card-text class="pa-4">
                        <div class="text-body-1 mb-4">
                            Ste si istý, že chcete odoslať Dar vo výške <strong>{{ formatCurrency(investmentAmount)
                                }}</strong>?
                        </div>

                        <v-alert type="info" outlined>
                            Po potvrdení bude vytvorená dohoda a budete presmerovaný na platbu.
                            Dohoda nadobúda účinnosť až po pripísaní sumy na náš účet.
                        </v-alert>

                        <div class="mt-4">
                            <v-checkbox v-model="agreementChecked"
                                :rules="[v => !!v || 'Musíte súhlasiť s podmienkami']">
                                <template v-slot:label>
                                    <div>
                                        Súhlasím s podmienkami dohody o Dare a potvrdzujem, že som si prečítal
                                        všetky dôležité informácie.
                                    </div>
                                </template>
                            </v-checkbox>
                        </div>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="grey" @click="confirmationDialog = false">
                            Zrušiť
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="success" :disabled="!agreementChecked" @click="finalConfirmInvestment"
                            :loading="loading">
                            Definitívne potvrdiť
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-dialog>

    </div>
</template>

<script>
import { formatCurrency } from '@/utils/investment-math';
import { COMPANY, PROJECT_COUNT, INVESTMENT_TARGET_CAPITAL } from '@/config/investment';

export default {
    name: "ContractPreviewDialog",

    components: {},

    props: {
        value: {
            type: Boolean,
            default: false
        },
        investmentAmount: {
            type: Number,
            default: 0
        },
        userInfo: {
            type: Object,
            default: () => ({
                id: 1,
                first_name: '',
                last_name: '',
                email: '',
                address: '',
                birth_number: '',
                bank_account: ''
            })
        },
        investmentBreakdown: {
            type: Array,
            default: () => []
        },
        contractEffectiveDate: {
            type: [String, Date],
            default: null
        }
    },

    data() {
        return {
            company: { ...COMPANY },
            projectCount: PROJECT_COUNT,
            investmentTargetCapital: INVESTMENT_TARGET_CAPITAL,
            loading: false,
            pdfLoading: false,
            confirmationDialog: false,
            agreementChecked: false,
            proposalDate: new Date(),
            // investmentId: null
        };
    },

    computed: {
        investmentId() {
            return `${this.userInfo.id}/X`;
        },

        currentCoefficient() {
            if (Array.isArray(this.investmentBreakdown) && this.investmentBreakdown.length > 0) {
                const parsed = Number(this.investmentBreakdown[0].coefficient);
                if (Number.isFinite(parsed) && parsed > 0) {
                    return parsed;
                }
            }
            return 1.5;
        },

        dialogVisible: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    },

    mounted() {
        // Generate investment ID when component mounts
        // this.generateInvestmentId();
    },

    methods: {
        closeDialog() {
            this.dialogVisible = false;
            this.confirmationDialog = false;
            this.agreementChecked = false;
        },

        confirmInvestment() {
            this.confirmationDialog = true;
        },

        finalConfirmInvestment() {
            if (!this.agreementChecked) return;

            this.loading = true;

            const investmentData = {
                investment_id: this.investmentId,
                investment_amount: this.investmentAmount,
                proposal_date: this.proposalDate,
                user_info: this.userInfo,
                bank_account: {
                    iban: this.company.iban,
                    recipient: this.company.name
                }
            };

            this.$emit('confirm', investmentData);
            this.loading = false;
            this.confirmationDialog = false;
            this.agreementChecked = false;
            this.closeDialog();
        },

        formatCurrency,

        formatDate(date) {
            if (!date) return '';
            const d = new Date(date);
            return d.toLocaleDateString('sk-SK', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
        },

        copyToClipboard(text) {
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(text).then(() => {
                    // Show success message
                    this.$emit('copied', text);
                }).catch(() => {
                    console.error('Failed to copy');
                });
            } else {
                // Fallback for older browsers
                const textArea = document.createElement('textarea');
                textArea.value = text;
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();
                try {
                    document.execCommand('copy');
                    this.$emit('copied', text);
                } catch (err) {
                    console.error('Failed to copy');
                }
                document.body.removeChild(textArea);
            }
        }
    }
};
</script>

<style scoped>
.contract-content {
    font-family: 'Times New Roman', serif;
    line-height: 1.6;
    background: #ecebe2;
    padding: 28px;
}

.contract-template {
    font-family: 'Times New Roman', serif;
    line-height: 1.72;
    white-space: pre-wrap;
    margin: 0 auto;
    max-width: 880px;
    background: #f9f9f9;
    border: 1px solid #bdbdbd;
    padding: 26px 30px;
    color: #111;
    font-size: 1.05rem;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
}

.contract-template--appendix {
    font-family: 'Courier New', monospace;
    line-height: 1.62;
    tab-size: 8;
}

.appendix-title {
    max-width: 880px;
    margin: 18px auto 10px;
    padding: 10px 14px;
    font-family: 'Times New Roman', serif;
    font-size: 1.35rem;
    font-weight: 700;
    letter-spacing: 0.02em;
    background: #fff3cd;
    border: 1px solid #d6b656;
    border-left: 6px solid #b8860b;
    color: #2a2a2a;
}

.line-height-1-6 {
    line-height: 1.6;
}

.contract-content h2 {
    margin-bottom: 1rem;
}

.contract-content p {
    margin-bottom: 0.8rem;
    text-align: justify;
}

.contract-content ol,
.contract-content ul {
    margin-bottom: 1rem;
}

.contract-content li {
    margin-bottom: 0.4rem;
}

.v-card>>>.v-card__subtitle {
    padding-bottom: 8px;
}

/* Print styles */
@media print {
    .v-dialog {
        position: static !important;
    }

    .v-card-actions {
        display: none !important;
    }

    .v-alert {
        border: 1px solid #ccc !important;
    }

    .contract-content {
        font-size: 11pt;
    }
}

/* Mobile responsive */
@media (max-width: 600px) {
    .contract-content {
        font-size: 0.9rem;
        padding: 10px;
    }

    .contract-template {
        padding: 14px;
        font-size: 0.95rem;
        line-height: 1.55;
    }

    .appendix-title {
        font-size: 1.1rem;
        margin: 14px auto 8px;
        padding: 8px 10px;
    }

    .text-h4 {
        font-size: 1.5rem !important;
    }

    .text-h5 {
        font-size: 1.3rem !important;
    }

    .text-h6 {
        font-size: 1.1rem !important;
    }
}

/* PDF Generation Styles */
#contract-content {
    background: white;
    color: black;
}

#contract-content .v-card {
    border: 1px solid #ddd !important;
    box-shadow: none !important;
}

#contract-content .v-alert {
    border: 1px solid #1976d2 !important;
    background: #e3f2fd !important;
}
</style>
